import { IPivotStyles, Pivot, PivotItem, getTheme } from "@fluentui/react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useNavigateWithParams } from "utils/components/LinkWithParams";
import { ICredentialInfo } from "types/stac";
import { CredentialsTab } from "./Settings.CredentialsTab";

interface SettingsTabsProps {
  credentials: ICredentialInfo[];
  isLoading: boolean;
  onNextPage: () => void;
  onPreviousPage: () => void;
  onPageChange: (size: number) => void;
}

export const SettingsTabs = ({
  credentials,
  isLoading,
  onNextPage,
  onPreviousPage,
  onPageChange,
}: SettingsTabsProps) => {
  const location = useLocation();
  const navigate = useNavigateWithParams();
  const [activeTab, setActiveTab] = useState("overview");
  useEffect(() => {
    setActiveTab(location.hash.replace("#", ""));
  }, [location]);

  const handleTabChange = (pivotItem?: PivotItem) => {
    if (!pivotItem) return;

    const { itemKey } = pivotItem.props;
    navigate(`#${itemKey}`, { replace: true });

    // Handle scroll to sticky-top when switching tabs
    const headerHeight = 360;
    if (window.scrollY > headerHeight) {
      window.scrollTo({ top: headerHeight, behavior: "smooth" });
    }
  };

  const pivot = (
    <Pivot
      styles={pivotHeaderStyle}
      selectedKey={activeTab}
      onLinkClick={handleTabChange}
      aria-label="Settings detail tabs"
    >
      <PivotItem
        headerText="Ingestion sources"
        itemKey="credentials"
        aria-label="Ingestion sources"
      >
        <CredentialsTab
          credentials={credentials}
          isLoading={isLoading}
          onNextPage={onNextPage}
          onPreviousPage={onPreviousPage}
          onPageChange={onPageChange}
        />
      </PivotItem>
    </Pivot>
  );

  return pivot;
};

const theme = getTheme();
const pivotHeaderStyle: Partial<IPivotStyles> = {
  root: {
    zIndex: 1,
    backgroundColor: theme.semanticColors.bodyBackground,
    paddingBottom: 0,
    marginBottom: 4,
    "&.is-pinned": {
      boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.5)",
    },
  },
};
